export default "__VITE_ASSET__D_gEwHj2__"